import moment from 'moment';
import 'moment/locale/fr';
import userPlaceholder from '../../assets/user.png';

moment.locale('fr');

const calendarOpts = {
  sameDay: "[Aujourd'hui à] LT",
  nextDay: '[Demain à] LT',
  nextWeek: 'dddd [à] LT',
  lastDay: '[Hier à] LT',
  lastWeek: '[Dernier] dddd [à] LT',
  sameElse: 'DD/MM/YYYY',
};

/* Message reçu (de l'autre côté) — affiché à gauche */
function InboxMessageItem({ data }) {
  const isGuest = window.localStorage.getItem('mode') === 'guest';
  const avatar = isGuest
    ? data?.Reservation?.Invite?.profile_url || userPlaceholder
    : data?.Reservation?.Host?.profile_url || userPlaceholder;

  return (
    <div className="d-flex align-items-end gap-2 mb-3">
      {/* Avatar */}
      <img
        src={avatar}
        alt="avatar"
        style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          objectFit: 'cover',
          flexShrink: 0,
        }}
      />
      {/* Bulle */}
      <div style={{ maxWidth: '70%' }}>
        <div
          className="px-3 py-2 rounded-3 rounded-bottom-start-0"
          style={{ background: '#e9ecef', color: '#212529', wordBreak: 'break-word' }}
        >
          <p className="mb-0" style={{ fontSize: '14px' }}>
            {data.message}
          </p>
        </div>
        <small className="text-muted ms-1" style={{ fontSize: '11px' }}>
          {moment(data.createdAt).calendar(null, calendarOpts)}
        </small>
      </div>
    </div>
  );
}

export default InboxMessageItem;
